// Money helpers with no imports, so the pure rule modules, the server and
// node tests can all use the same ones (audit OPS-25 / Phase 9: three
// copies of the currency formatter, and a rounding helper named "money").
//
//   formatUsd(1500)   -> "$1,500.00"   (NaN / null / "" -> "$0.00")
//   round2(33.335)    -> 33.34         (to the cent)
const n0 = (v) => { const x = Number(v); return Number.isFinite(x) ? x : 0; };

export const formatUsd = (v) => "$" + n0(v).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const round2 = (v) => Math.round(n0(v) * 100) / 100;
